import { path, mapObjIndexed, isEmpty, isNil, startsWith, drop } from 'ramda';
import { wrapAssetPath } from '../../utils';
import { iconVariants as icons } from './icons';
export default (function (configuredTheme) {
  var themeNameProp = path(['theme', 'name'], configuredTheme);
  var themeName = themeNameProp === 'simply' ? 'base' : themeNameProp;
  var wrappedIconPaths = mapObjIndexed(function (key) {
    if (!isEmpty(key[themeName] && !isNil(key[themeName]))) {
      return wrapAssetPath(configuredTheme, key[themeName]);
    }

    return wrapAssetPath(configuredTheme, key['base']);
  }, icons);

  if (configuredTheme.theme.unSlashAssetUrlsInCss === true) {
    return {
      icons: wrappedIconPaths,
      iconsForCssUrls: mapObjIndexed(function (filePath) {
        return startsWith('/', filePath) ? drop(1, filePath) : filePath;
      }, wrappedIconPaths)
    };
  }

  return {
    icons: wrappedIconPaths,
    iconsForCssUrls: wrappedIconPaths
  };
});